import { render } from "./ResourceDetailsTab.vue?vue&type=template&id=69e00300&scoped=true"
import script from "./ResourceDetailsTab.vue?vue&type=script&lang=js"
export * from "./ResourceDetailsTab.vue?vue&type=script&lang=js"

import "./ResourceDetailsTab.vue?vue&type=style&index=0&id=69e00300&scoped=true&lang=scss"

import exportComponent from "/build/cloudstack/dist/rpmbuild/BUILD/cloudstack-4.18.1.0/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69e00300"]])

export default __exports__